export const NEWSLETTER_LOADING = "NEWSLETTER_LOADING";
export const SUBSCRIBE_NEWSLETTER_SUCCESS = "SUBSCRIBE_NEWSLETTER_SUCCESS";
export const SUBSCRIBE_NEWSLETTER_FAIL = "SUBSCRIBE_NEWSLETTER_FAIL";
export const REMOVE_NEWSLETTER_DATA = "REMOVE_NEWSLETTER_DATA";
